import Vue from 'vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import VueMaterial from 'vue-material'
import VueI18n from 'vue-i18n';
import VueLocalStorage from 'vue-localstorage';
import VueLayers from 'vuelayers';
import Notifications from 'vue-notification';
import Loading from 'vue-loading-overlay';
import vueScrollTo from 'vue-scroll-to';
//import vPage from 'v-page';
import vPage from '../my_modules/v-page/src/index.js';
import VueInstant from 'vue-instant';
import vSelect from 'vue-select';
import WebCam from 'vue-web-cam';
import VueTour from 'vue-tour';
import vueHeadful from 'vue-headful';
import Tooltip from 'vue-directive-tooltip';
//import DisableAutocomplete from 'vue-disable-autocomplete';
//import JsonExcel from 'vue-json-excel';
//import VueQrcodeReader from 'vue-qrcode-reader';
import LiquorTree from 'liquor-tree';
//import * as VueGoogleMaps from 'vue2-google-maps';
//import VueAWN from "vue-awesome-notifications";

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css';
import 'vuelayers/lib/style.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-instant/dist/vue-instant.css';
import 'vue-tour/dist/vue-tour.css';
import 'vue-directive-tooltip/css/index.css';

import 'devextreme/dist/css/dx.common.css'
//import 'devextreme/dist/css/dx.dark.css';
import 'devextreme/dist/css/dx.light.compact.css';

import "jquery-ui/themes/base/all.css";
import "devextreme/dist/css/dx.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";


import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";

//import 'vue-awesome-notifications/dist/styles/style.css';
import "devexpress-dashboard/dist/css/dx-dashboard.light.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.dark.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.carmine.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.darkmoon.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.darkviolet.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.greenmist.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.softblue.css";

//let AWNOptions = {
//  position: "bottom-right",
//};

//Vue.use(VueAWN, AWNOptions);

Vue.use(VueMaterial);
Vue.use(VueI18n);
Vue.use(VueLocalStorage);
Vue.use(VueLayers);
Vue.use(Notifications);
Vue.use(Loading);
Vue.use(vueScrollTo);
Vue.use(vPage, {
  info: true,
  language: 'cn',
  pageSizeMenu: () => ([10, 25, 50, 100]),
  align: 'center'
});
Vue.use(VueInstant);
Vue.component('v-select', vSelect);
Vue.use(WebCam);
Vue.use(VueTour);
Vue.component('vue-headful', vueHeadful);
Vue.use(require('vue-shortkey'));
Vue.use(Tooltip);
//Vue.use(DisableAutocomplete);
//Vue.component('downloadExcel', JsonExcel);
//Vue.use(VueQrcodeReader);
Vue.use(LiquorTree);
//Vue.use(VueGoogleMaps, {
//  load: {
//    key: 'AIzaSyDrc9okYRYhkWwAeavICKZdDKqcTyZ8TUo',
//    libraries: 'places,drawing,visualization,geometry'
//  },
//});

Vue.config.productionTip = false;

var enJSON = require('./i18n/en.json');
var elJSON = require('./i18n/el.json');
var ruJSON = require('./i18n/ru.json');
var arJSON = require('./i18n/ar.json');

var messages = {
  en: enJSON,
  el: elJSON,
  ru: ruJSON,
  ar: arJSON,
};

new Vue({
  router,
  store,
  render: (h) => h(require('./app/app.vue').default),
  i18n: new VueI18n({
    locale: localStorage.getItem('_lang') || 'el',
    fallbackLocale: 'en',
    messages: messages,
  }),
}).$mount('#app');

Vue.prototype.$isJsonValid = function (json) {

  if (json == null || json == '')
    return false;

  try {
    JSON.parse(json);
  } catch (e) {
    return false;
  }

  return true;
};
